module.exports = __webpack_public_path__ + "img/girl.08348c7a.svg";